import React from "react";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { Cluster } from "@/components/common/Stack";
import { TruncatedText } from "@/components/common/TruncatedText";

/// A wrapping set of table chips (table icon + name), styled to match the
/// Related-links / Labels chips so affected-table lists read consistently across
/// the datasets UI. Each chip hugs its label with consistent padding; the name
/// truncates only when it would overflow the available row width (`max-w-full`
/// + shrinkable inner text), never sooner.
export const TableChips: React.FC<{
  tables: { table_id: string; name: string; note?: string }[];
}> = ({ tables }) => (
  <Cluster gap="sm">
    {tables.map((t) => (
      <span
        key={t.table_id}
        className="inline-flex items-center gap-1 min-w-0 max-w-full min-h-(--control-height-sm) px-2 py-0.5 rounded-app border border-border text-fg"
      >
        <TableChartOutlinedIcon className="icon-xs text-fg-muted shrink-0" />
        <TruncatedText className="min-w-0">{t.name}</TruncatedText>
        {t.note && <span className="shrink-0 text-fg-muted">· {t.note}</span>}
      </span>
    ))}
  </Cluster>
);
